import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the state type - UI state only
interface MessagesUiState {
  // Logging status for in-progress operations
  loggingStatus: 'idle' | 'loading' | 'succeeded' | 'failed';
}

// Initial state
const initialState: MessagesUiState = {
  loggingStatus: 'idle',
};

// Note: Messages are now fetched using RTK Query hooks from the API layer
// See: useGetMessagesForConversationQuery from '@/api/features/messaging'

// Note: Message selection lives in MessageSelectionProvider (React Context),
// NOT in Redux. Consumed via the useMessageSelection() hook.

// Create the slice
const messagesUiSlice = createSlice({
  name: 'messaging/messagesUi',
  initialState,
  reducers: {
    // Set the logging status (used by useMessageHandling during log operations)
    setLoggingStatus(state, action: PayloadAction<MessagesUiState['loggingStatus']>) {
      state.loggingStatus = action.payload;
    },
  },
});

// Export actions
export const {
  setLoggingStatus,
} = messagesUiSlice.actions;

// Export selectors — typed with slice state to avoid circular dep on RootState
export const selectLoggingStatus = (state: { messages: MessagesUiState }) => state.messages.loggingStatus;

export default messagesUiSlice.reducer;
